import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { validateAndCleanToken, getDefaultRoute, getCurrentUser } from './authUtils';

/**
 * Component to handle root path redirects
 * If there's a token parameter, redirect to AuthCallback
 * If user is already authenticated, redirect to integrations
 * Otherwise, redirect to login
 */
function RootRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {

    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get('token');
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (token || code || error) {
      // Redirect to AuthCallback with the same query parameters
      navigate(`/auth/callback${location.search}`, { replace: true });
    } else if (validateAndCleanToken()) {
      // User is already authenticated, redirect to their default route
      const user = getCurrentUser();
      navigate(getDefaultRoute(user), { replace: true });
    } else {
      // No token and not authenticated, redirect to login
      navigate('/login', { replace: true });
    }
  }, [navigate, location]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '18px',
      color: '#666',
    }}>
      Redirecting...
    </div>
  );
}

export { RootRedirect };
